up.compiler(".up_modify_hours", function (element) {
  const start_hour_hours = element.querySelector("#start_hour_hours");
  const start_hour_minutes = element.querySelector("#start_hour_minutes");
  const end_hour_hours = element.querySelector("#end_hour_hours");
  const end_hour_minutes = element.querySelector("#end_hour_minutes");

  function inputCallback(evt) {
    let input = evt.target;

    let min = parseInt(input.getAttribute("min"), 10);
    let max = parseInt(input.getAttribute("max"), 10);
    let value = parseInt(input.value, 10);

    if (isNaN(value)) return;

    if (value < min) input.value = min;
    if (value > max) input.value = max;

    if (input.value.length === 2) {
      let nextInputId = input.dataset.next;
      if (nextInputId) element.querySelector("#" + nextInputId).focus();
    }
  }

  start_hour_hours.addEventListener("input", inputCallback);
  start_hour_minutes.addEventListener("input", inputCallback);
  end_hour_hours.addEventListener("input", inputCallback);
  end_hour_minutes.addEventListener("input", inputCallback);

  return () => {
    start_hour_hours.removeEventListener("input", inputCallback);
    start_hour_minutes.removeEventListener("input", inputCallback);
    end_hour_hours.removeEventListener("input", inputCallback);
    end_hour_minutes.removeEventListener("input", inputCallback);
  };
});
